var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoElement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54593 14.1889L9.30036 17.6009L4.75547 19.9999L0 16.5879V10.6656L4.54593 8.2666V14.1889Z",
    fill: "#00EC7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28769 5.81096L4.53223 2.40004L9.07815 0L13.8326 3.41197V9.33431L9.28666 11.7333L9.28769 5.81096Z",
    fill: "#00EC7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElement);
export default __webpack_public_path__ + "static/media/logo_element.d3aabc53f3beecf5c9162db8e561f173.svg";
export { ForwardRef as ReactComponent };